import Vue from "vue";
import Router from "vue-router";

//  Main Pages
import Index from "./views/Index.vue";


import MainNavbar from "./layout/MainNavbar.vue";
import EvoNavbar from "./layout/EvoNavbar";
import MainFooter from "./layout/MainFooter.vue";
import Error from "./views/examples/Error";
import test1 from "./components/Custom/test";
import Landing from "./views/examples/Landing";
import EvoFooter from "./layout/EvoFooter";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "evotor",
      components: {default: Landing, header: EvoNavbar, footer: EvoFooter },
    },
    {
      path: '*',
      components: {default: Error},
    }

  ],
});
